import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Formik, Form } from 'formik'
import { useDispatch } from 'react-redux'
import { Dispatch } from '@/store'
import useMediaQuery from '@/hooks/use-media-query'
import { Heading, ParagraphRegular } from '@/components/text'
import { Button } from '@/components/button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { Stack, Box } from '@/components/structure'
import { breakpoints, colors } from '@/styles'
import { useStopPadSuccessModal } from '@/features/Pad'

const FormContents = styled(Form)`
  display: contents;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  > :first-child {
    margin-right: 24px;
  }
`

type StopPadProps = {
  contractId?: String
  listingAddress?: String
  submitAction?: () => void
}

const StopPadPaymentsModal: React.FC<StopPadProps> = ({
  contractId,
  submitAction,
  listingAddress
}) => {
  const { t } = useTranslation()
  const { close } = useModalize()
  const dispatch = useDispatch<Dispatch>()
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const padding = displayMobile ? 24 : 32
  const { show: showSuccessModal } = useStopPadSuccessModal()

  const handleSubmit = async () => {
    const { response } = await dispatch.contract.stopPadPayments({
      contractId
    })
    if (response.ok) {
      submitAction?.()
      showSuccessModal()
      close()
    }
  }

  const handleCancelRequest = () => close()

  return (
    <Box ptop={padding + 20} pbottom={padding} pleft={padding} pright={padding}>
      <Stack gutter="32px">
        <Stack gutter="8px">
          <Box textAlign="center" justify="center">
            <Heading type={!displayMobile ? 'h4' : 'h5'}>
              {t('r.pad_settings.edit.stop_pad.heading', 'Are you sure?')}
            </Heading>
          </Box>
          <Box textAlign="center" justify="center" color={colors.grey56}>
            <ParagraphRegular>
              {t(
                'r.pad_settings.edit.stop_pad.text',
                `Are you sure you want to stop the PAD Rent Payment Service with Liv Strategies Inc. for ${listingAddress}?`
              )}
            </ParagraphRegular>
          </Box>
        </Stack>
        <Formik initialValues={{}} onSubmit={handleSubmit}>
          {() => (
            <FormContents>
              <ButtonWrapper>
                <Button theme="secondary" onClick={handleCancelRequest}>
                  {t('common.cancel', 'Cancel')}
                </Button>
                <Button type="submit" theme="delete">
                  {t('r.pad_settings.edit.stop_pad.stop_service.option', 'Stop Service')}
                </Button>
              </ButtonWrapper>
            </FormContents>
          )}
        </Formik>
      </Stack>
    </Box>
  )
}

const show = createModal(StopPadPaymentsModal, { width: '492px' })

export default show
